import React, { useEffect, useState, useRef } from "react";
import style from "./cargoModal.module.scss";
import Modal from '../Modal/Modal'
import Toast from '../Toast/Toast'
import DropDown from "../Dropdown/SimpleDropDown/DropDown";
import { GetWarehouses, WarehouseData } from "../../actions/APIcalls";
import { HTML5Backend } from 'react-dnd-html5-backend'
import { DndProvider } from 'react-dnd'
import CargoTab from './components/cargoModalTab'


const CargoModal = (props) => {

    const [loading, setLoading] = useState(true)
    const [toast, setToast] = useState({ text: '', type: 'error' })
    useEffect(async () => {
        // await GetWarehousesFunction()
        await setConfigData()
        setLoading(false)
    }, [])

    useEffect(async () => {
        await setConfigData()
    }, [props.cargoConfigs])

    useEffect(() => {
        if (!props.show) {
            unsetData()
        }
    }, [props.show])

    const setConfigData = () => {
        if (props.cargoConfigs && props.cargoConfigs.length > 0) {
            let tmp = modalData
            tmp.cargoConfigs = props.cargoConfigs
            tmp.cargoConfigsChannels = props.cargoConfigs.map(el => el.channel._id)
            setModalData({ ...tmp })
        }
    }

    const unsetData = () => {
        // unset data
    }

    const [modalData, setModalData] = useState({
        channels: props.channels,
        cargoConfigsChannels: [],
        cargoConfigs: [],
        wareHouses: [],
        cargoType: 'small',
        tab: 0
    })

    const GetWarehousesFunction = async () => {
        let list = await GetWarehouses()
        if (list && list.data && list.data.success) {
            let tmp = modalData
            tmp.wareHouses = list.data.list
            setModalData({ ...tmp })
        }
    }

    const createCargofunction = async (params, type) => {
        setToast({ ...toast, text: '' })
        let res = await props.updateCargoConfigs(params, type)

        if (res.data && res.data.success) {
            props.closeModal()
        }
    }

    const changeChannel = (tag, value) => {
        let tmp = modalData
        tmp.channels.map((channel, index) => {
            if (channel._id == value._id) {
                tmp.tab = index
            }
        })
        setModalData({ ...tmp })
    }

    const deleteFromSelected = () => {
        let tmp = modalData
        tmp.tab = 0
        setModalData({ ...tmp })
    }

    const getWareHouseData = async (deliverType) => {
        setToast({ ...toast, text: '' })
        let params = {
            channelId: modalData.channels[modalData.tab]._id,
            deliveryType: deliverType,
            shippingNatureId: modalData.cargoType == 'small' ? 1 : 2
        }
        let res = await WarehouseData(params)
        let array = []
        if (res && res.data && res.data.success) {
            let tmp = modalData
            array = Object.keys(res.data.list).map((key, index) => {
                let obj = {
                    id: res.data.list[key].id,
                    name: res.data.list[key].title,
                    checked: false
                }
                return obj
            })
            tmp.wareHouses = array
            setModalData({ ...tmp })
        } else {
            setToast({ ...toast, text: 'اطلاعات انبارها در حال حاضر وجود ندارد' })
        }
        return array
    }

    return (
        <>
            <Modal
                value={props.show}
                title='تنظیمات ساخت محموله'
                parentClose={props.closeModal}
            >
                <Toast
                    tag={'cargoTag'}
                    value={toast.text}
                    type={toast.type}
                    text={toast.text}
                    parentClose={() => setToast({ ...toast, text: '' })}
                />
                {loading ? <div className={style.priceLoading}><span>.</span><span>.</span><span>.</span></div>
                    :
                    <div className={style.wrapper}>

                        <div className={style.tabWrapper}>
                            <div className={style.tabFlexBox}>
                                <div className={modalData.cargoType == 'small' ? style.tabFlexItemActive : style.tabFlexItem} onClick={() => setModalData({ ...modalData, cargoType: 'small' })}>محموله‌های کوچک</div>
                                <div className={modalData.cargoType == 'big' ? style.tabFlexItemActive : style.tabFlexItem} onClick={() => setModalData({ ...modalData, cargoType: 'big' })}>محموله‌های متوسط و بزرگ</div>
                            </div>
                        </div>

                        {modalData.channels.length > 1 &&
                            <div className={style.channelWrapper}>
                                <p className={style.channelLabel}>پنل فروش</p>
                                <DropDown
                                    tag='channel'
                                    label=''
                                    placeHolder={modalData.channels[modalData.tab].name}
                                    value={modalData.channels[modalData.tab].name}
                                    dropdownList={modalData.channels}
                                    hasCheckbox={false}
                                    handleSelect={changeChannel}
                                    onblure={() => { }}
                                    deleteSelectedItems={deleteFromSelected}
                                    errorMessage=''
                                />
                            </div>
                        }

                        <DndProvider backend={HTML5Backend}>
                            {modalData.channels.map((channelItem, index) => <div key={index}>
                                {modalData.tab == index && <>
                                    <CargoTab
                                        natureType={modalData.cargoType}
                                        data={modalData.cargoConfigsChannels.includes(channelItem._id) ? modalData.cargoConfigs.filter(el => {
                                            if ((el.channel._id).toString() == (channelItem._id).toString() && el.natureType == modalData.cargoType) {
                                                return el
                                            }
                                        })[0] : null}
                                        channel={channelItem}
                                        createCargofunction={createCargofunction}
                                        wareHouses={modalData.wareHouses}
                                        getWareHouseData={getWareHouseData}
                                        closeModal={props.closeModal}
                                    />
                                </>}
                            </div>
                            )}
                        </DndProvider>

                    </div>
                }
            </Modal>
        </>
    );
}

export default CargoModal;
